import React from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import {
  RegisterForm,
  PageTitle,
  ConfirmModal,
  EntainPattern,
} from "src/library/components/exports";
import { ConfirmModalTextProps } from "src/library/types/types";
import { zIndexes } from "src/library/styles/theme";
import CONTENT from "src/library/content.json";

const initialState: ConfirmModalTextProps = {
  title: "This is a default title",
  message: "This is a default message.",
  confirmButton: "OK",
  cancelButton: "Cancel",
};

export default function Register() {
  const [confirmModal, setConfirmModal] = React.useState(false);
  const [confirmModalText, setConfirmModalText] = React.useState(initialState);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    pageTitles: { register },
  } = CONTENT;

  const openConfirmModal = (props: ConfirmModalTextProps) => {
    setConfirmModalText({
      title: props.title,
      message: props.message,
      confirmButton: props.confirmButton,
      cancelButton: props.cancelButton,
    });
    setConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setConfirmModal(false);
  };

  return (
    <Box
      sx={{
        pt: isMobile ? "50px" : 0,
        bgcolor: "primary.main",
        minHeight: "80vh",
        zIndex: zIndexes.Base,
      }}
      component="main"
    >
      <PageTitle
        title={register}
        style={{ zIndex: zIndexes.Above, bgcolor: "transparent" }}
      />
      <RegisterForm
        confirmModal={confirmModal}
        openConfirmModal={openConfirmModal}
        closeConfirmModal={closeConfirmModal}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        confirmModalText={confirmModalText}
        openConfirmModal={openConfirmModal}
        closeConfirmModal={closeConfirmModal}
      />
      <EntainPattern />
    </Box>
  );
}
